import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, map, throwError } from 'rxjs';
import { BASEURL } from '../constant/url';
import { User, UserCreate, Users } from '../interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private readonly _http = inject(HttpClient);

  fetchUsers(page: number, pageSize?: number, query?: string): Observable<Users> {
    let url = `${BASEURL}users?sort=id:desc&populate=categories&pagination[page]=${page}&pagination[pageSize]=${pageSize || 10}`;
    if (query) {
      url += `&filters[$or][0][username][$containsi]=${encodeURIComponent(query)}&filters[$or][1][email][$containsi]=${encodeURIComponent(query)}`;
    }
    return this._http.get<Users>(url).pipe(
        map((response: Users) => response),
        catchError(this.handleError)
      );
  }

  getUser(id: number): Observable<User> {
    return this._http
      .get<User>(BASEURL + 'users/' + id + '?populate=categories')
      .pipe(
        map((response: User) => response),
        catchError(this.handleError)
      );
  }

  addUser(data: UserCreate): Observable<User> {
    return this._http.post<User>(BASEURL + 'invite-user', data).pipe(catchError(this.handleError));
  }

  deleteUser(id: number): Observable<void> {
    return this._http.delete<void>(BASEURL + 'users/' + id).pipe(catchError(this.handleError));
  }

  updateUser(id: number, data: User): Observable<User> {
    return this._http.put<User>(BASEURL + 'users/' + id, data).pipe(catchError(this.handleError));
  }

  activationUser(token: string, password: string): Observable<string> {
    const data = {
      token,
      password,
    };
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this._http.post<string>(BASEURL + 'complete-registration', data, {
      headers,
    }).pipe(catchError(this.handleError));
  }

  resetPassword(
    password: string,
    passwordConfirmation: string,
    code: string
  ): Observable<string> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const data = {
      password: password,
      passwordConfirmation: passwordConfirmation,
      code: code,
    };

    return this._http.post<string>(BASEURL + 'auth/reset-password', data, {
      headers,
    }).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Error en el servicio de Usuarios.';
    if (error.error && error.error.error && error.error.error.message) {
      errorMessage = error.error.error.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    console.error('UsersService error:', errorMessage, error.error || error);
    return throwError(() => new Error(errorMessage));
  }
}
